<template>
  <div class="aplication">

    <template v-if="!$store.state.loading">

      <template v-if="!$store.state.user.cadastrar_senha">       

        <div v-if="([0, 1, 2, 3, 9, 12].includes(Number($store.state.user.tipo)) && $store.state.config.instituicao.id) || [4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo))">
            <div class="tarja-header">
              <div class="logo" :style="{'width': ((collapsed || isMobile) ? '60px' : '240px') }">
                <router-link to="/">
                  <div v-if="!collapsed && !isMobile" style="display: flex; padding: 5px 15px;">

                      <svg style="width: 120px; enable-background:new 0 0 1000 250;" version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 1000 250" xml:space="preserve">
                      <path class="st0" d="M14.44,124.86c0-17.45,0.06-34.91-0.03-52.36c-0.04-8.56,3.65-14.53,11.36-18.27
                        c25.09-12.18,50.13-24.46,75.19-36.7c2.82-1.38,3.11-1.21,3.15,1.9c0.03,2.52,0.06,5.04-0.06,7.56c-0.1,2.09,0.42,2.79,2.47,1.64
                        c1.95-1.09,4.06-1.9,6-3.01c2.22-1.26,2.75-0.34,2.71,1.77c-0.05,2.33,0.01,4.67-0.01,7c-0.02,1.44,0.47,1.87,1.85,1.16
                        c2.32-1.19,4.69-2.3,7.04-3.43c3.33-1.6,3.39-1.56,3.41,2.27c0.01,2.05,0.04,4.11,0.01,6.16c-0.03,1.76,0.63,2.15,2.2,1.34
                        c2.57-1.32,5.21-2.51,7.78-3.84c1.73-0.9,2.59-0.71,2.51,1.46c-0.08,2.14-0.01,4.29-0.01,6.44c0.01,3.8,0.01,3.84,3.84,3.36
                        c10.66-1.33,20.8,0.52,30.55,4.85c7.82,3.47,11.61,9.5,11.6,18.08c-0.04,35.19-0.06,70.37,0.01,105.55
                        c0.02,8.69-3.82,14.64-11.6,18.41c-24.85,12.04-49.64,24.18-74.45,36.29c-3.46,1.69-3.64,1.59-3.64-2.24c0-2.33-0.03-4.67,0.04-7
                        c0.06-2.14-0.78-2.38-2.52-1.47c-2.23,1.17-4.55,2.17-6.79,3.31c-1.51,0.77-2.04,0.27-2.02-1.29c0.02-2.71-0.04-5.41,0.01-8.12
                        c0.02-1.52-0.55-1.81-1.86-1.17c-2.51,1.24-5.02,2.47-7.55,3.67c-2.9,1.38-2.96,1.34-2.98-1.99c-0.01-1.96-0.13-3.93,0.03-5.88
                        c0.22-2.61-0.77-2.57-2.66-1.55c-2.46,1.32-5.03,2.45-7.53,3.7c-1.56,0.79-2.21,0.4-2.17-1.37c0.06-2.24,0.01-4.48,0.01-6.72
                        c0-3.88-0.01-3.95-3.73-3.45c-7.43,1-14.69,0.18-21.89-1.71c-3.35-0.88-6.59-2.06-9.69-3.6c-6.92-3.43-10.55-9.03-10.57-16.76
                        C14.4,160.89,14.44,142.88,14.44,124.86 M21.96,85.78v2.73c0,29.77,0.04,59.54-0.03,89.31c-0.01,5.74,2.4,9.53,7.71,11.7
                        c8.35,3.41,16.92,5.09,25.96,3.95c4.73-0.6,4.74-0.53,4.74-5.3c0-28.28,0.03-56.55-0.06-84.83c-0.01-2.51,0.77-3.79,3.04-4.89
                        c25.27-12.23,50.47-24.58,75.7-36.9c1.68-0.82,3.34-1.67,5.06-2.38c1.29-0.53,2.44-0.14,3.04,1.17c0.56,1.21,0.05,2.18-0.99,2.88
                        c-0.46,0.31-0.97,0.55-1.47,0.8c-25.72,12.57-51.44,25.16-77.19,37.67c-1.76,0.85-2.46,1.81-2.46,3.79
                        c0.06,32.48,0.06,64.95,0.01,97.43c0,2.41,0.57,3.14,2.77,1.78c0.55-0.34,1.15-0.64,1.77-0.83c2.57-0.76,3.21-2.45,3.16-5.05
                        c-0.16-8.21-0.06-16.42-0.06-24.64c0-21.65,0.05-43.3-0.07-64.95c-0.02-2.62,1.03-3.91,3.17-4.85c2.44-1.08,4.87-2.19,7.27-3.36
                        c20.62-10.05,41.24-20.13,61.86-30.19c5.78-2.82,11.57-5.64,17.35-8.47c1.48-0.73,2.8-0.64,3.54,0.92c0.67,1.42,0.01,2.52-1.34,3.22
                        c-0.58,0.3-1.16,0.6-1.75,0.89c-4.94,2.41-9.92,4.78-14.83,7.24c-22.32,11.21-45.09,21.52-67.23,33.12
                        c-2.8,1.47-3.29,2.76-3.29,5.33c0.04,31.64,0.03,63.27,0.03,94.91c0,4.14,0.01,4.16,3.75,2.31c1.92-0.95,4.02-1.35,4-4.51
                        c-0.14-29.77-0.05-59.54-0.17-89.31c-0.01-2.94,0.92-4.49,3.55-5.75c25.86-12.5,51.66-25.13,77.5-37.68
                        c1.71-0.83,3.94-2.71,5.24,0.15c1.18,2.6-1.5,3.19-3.16,4c-24.71,12.1-49.41,24.22-74.18,36.19c-2.98,1.44-4.22,3.12-4.21,6.54
                        c0.13,29.21,0.07,58.42,0.07,87.63c0,2.99-0.02,5.97,0.02,8.96c0.01,0.64-0.34,1.6,0.99,1.51c2.9-0.2,5.61-3.03,5.61-5.98
                        c-0.03-27.25-0.15-54.5,0-81.75c0.02-3.24-0.73-6.41-0.31-9.72c0.33-2.59,1.5-3.65,3.57-4.66c23.91-11.62,47.77-23.34,71.68-34.94
                        c4.36-2.11,7.13-5.19,7.09-10.1c-0.04-5.07-3-8.16-7.55-10.06c-14.61-6.12-29.06-5.86-43.31,1.03
                        c-17.05,8.24-34.06,16.56-51.04,24.92c-11.23,5.53-23.01,7.32-35.36,5.53C34.53,91.32,28.34,89.08,21.96,85.78 M178.49,85.79
                        c-1.72,0.84-2.89,1.42-4.05,1.99c-22.54,11-45.07,22.03-67.64,32.98c-1.93,0.94-2.73,1.97-2.6,4.24c0.22,3.85-0.11,7.73-0.11,11.6
                        c-0.02,26.96-0.01,53.92,0,80.89c0,4.63,0.01,4.64,4.26,2.57c20.86-10.19,41.68-20.47,62.61-30.53c5.29-2.54,7.59-6.31,7.57-12.12
                        c-0.1-26.78-0.03-53.55-0.03-80.33C178.49,93.46,178.49,89.85,178.49,85.79 M50.17,85.37c8.55-0.01,15.23-1.72,23.19-5.45
                        c20.18-9.44,39.63-20.42,60.39-28.64c1.36-0.54,2.4-3.9,1.43-5.61c-1.03-1.81-2.27-0.06-3.18,0.38
                        C107.58,57.9,83.2,69.82,58.81,81.73c-0.84,0.41-1.68,0.81-2.53,1.19c-1.3,0.58-2.45,0.33-3.13-0.93c-0.76-1.41-0.15-2.51,1.15-3.28
                        c0.4-0.24,0.83-0.43,1.25-0.63c15.34-7.49,30.67-14.98,46.01-22.47c6.37-3.11,12.75-6.2,19.11-9.33c1.77-0.87,3.08-4.97,1.78-6.81
                        c-1.29-1.83-2.76,0.13-3.95,0.71C92.07,53,65.68,65.91,39.26,78.77c-1.73,0.84-3.94,2.67-5.23-0.19c-1.19-2.64,1.55-3.18,3.18-3.98
                        c20.85-10.22,41.73-20.4,62.6-30.59c3.02-1.47,6.05-2.92,9.03-4.46c1.34-0.69,2.35-4.92,1.32-6.3c-1.25-1.66-2.49,0.08-3.54,0.59
                        C82.46,45.57,58.33,57.37,34.19,69.16c-0.67,0.33-1.35,0.65-2.04,0.92c-1.33,0.53-2.46,0.2-3.05-1.1c-0.59-1.29-0.11-2.37,1.12-3.08
                        c0.56-0.33,1.16-0.6,1.75-0.88c7.63-3.73,15.25-7.45,22.88-11.18c13.07-6.39,26.15-12.77,39.22-19.16c2.02-0.99,3.31-3.81,2.12-5.23
                        c-1.33-1.58-2.71,0.18-3.85,0.73C71.02,40.51,49.76,50.95,28.45,61.32c-4.1,2-6.43,5.15-6.42,9.66c0.01,4.64,2.47,7.86,6.71,9.76
                        C35.57,83.79,42.66,85.51,50.17,85.37"/>
                      <path class="st0" d="M380.34,54.29c2.97,0,4.45,1.49,4.45,4.45v19.23c0,2.97-1.48,4.45-4.45,4.45H278.93c-3.92,0-6.68,1.01-8.3,3.04
                        c-1.62,2.03-2.43,4.79-2.43,8.3v6.88c0,7.56,3.51,11.34,10.53,11.34h75.9c11.74,0,20.58,3,26.51,9.01
                        c5.94,6.01,8.91,14.61,8.91,25.81v16.19c0,9.85-2.9,17.81-8.7,23.88c-5.8,6.07-14.85,9.11-27.12,9.11H242.09
                        c-3.11,0-4.66-1.48-4.66-4.45v-19.23c0-2.97,1.55-4.45,4.66-4.45h106.26c3.91,0,6.68-1.01,8.3-3.04c1.62-2.02,2.43-4.79,2.43-8.3
                        v-8.3c0-7.56-3.51-11.34-10.52-11.34h-75.9c-11.74,0-20.58-3-26.51-9.01c-5.94-6-8.91-14.6-8.91-25.81V87.28
                        c0-9.85,2.9-17.81,8.7-23.88c5.8-6.07,14.84-9.11,27.12-9.11H380.34z"/>
                      <path class="st0" d="M453.2,54.29c2.97,0,5.53,0.2,7.69,0.61c2.16,0.41,4.05,1.18,5.67,2.33c1.62,1.15,3.07,2.7,4.35,4.66
                        c1.28,1.96,2.6,4.55,3.95,7.79l42.1,97.16c0.54,1.22,1.48,1.82,2.83,1.82h2.43c1.35,0,2.29-0.61,2.83-1.82l42.1-97.16
                        c1.35-3.24,2.66-5.84,3.95-7.79c1.28-1.95,2.73-3.51,4.35-4.66c1.62-1.14,3.47-1.92,5.57-2.33c2.09-0.4,4.62-0.61,7.59-0.61h21.66
                        c7.01,0,11.74,1.59,14.17,4.76c2.43,3.17,3.64,8.6,3.64,16.29v116.18c0,2.97-1.55,4.45-4.65,4.45h-20.65
                        c-2.97,0-4.45-1.48-4.45-4.45V85.86c0-1.35-0.54-2.02-1.62-2.02h-1.82c-1.35,0-2.23,0.54-2.63,1.62l-40.89,90.68
                        c-1.62,3.64-3.27,6.71-4.96,9.21c-1.69,2.5-3.51,4.55-5.47,6.17c-1.96,1.62-4.18,2.77-6.68,3.44c-2.5,0.68-5.43,1.01-8.81,1.01
                        h-9.71c-3.37,0-6.31-0.34-8.81-1.01c-2.5-0.67-4.72-1.82-6.68-3.44c-1.96-1.62-3.78-3.67-5.47-6.17c-1.69-2.5-3.34-5.57-4.96-9.21
                        l-40.89-90.68c-0.41-1.08-1.28-1.62-2.63-1.62h-1.82c-1.08,0-1.62,0.68-1.62,2.02v105.66c0,2.97-1.49,4.45-4.45,4.45h-20.64
                        c-3.11,0-4.66-1.48-4.66-4.45V75.34c0-7.69,1.21-13.12,3.64-16.29c2.43-3.17,7.22-4.76,14.37-4.76H453.2z"/>
                      <path class="st0" d="M812.48,54.29c2.97,0,4.45,1.49,4.45,4.45v19.84c0,3.11-1.49,4.66-4.45,4.66H711.07
                        c-5.26,0-9.61,0.44-13.06,1.32c-3.44,0.88-6.17,2.36-8.2,4.45c-2.02,2.09-3.48,4.89-4.35,8.4c-0.88,3.51-1.32,7.96-1.32,13.36v29.15
                        c0,5.4,0.44,9.89,1.32,13.46c0.88,3.58,2.33,6.41,4.35,8.5c2.03,2.09,4.76,3.58,8.2,4.45c3.44,0.88,7.79,1.32,13.06,1.32h66.79
                        c3.51,0,6.07-0.91,7.69-2.73c1.62-1.82,2.43-5.03,2.43-9.62v-16.39c0-1.75-0.81-2.63-2.43-2.63h-59.31c-2.97,0-4.45-1.55-4.45-4.66
                        v-15.18c0-3.1,1.48-4.66,4.45-4.66h84.4c4.05,0,6.07,2.02,6.07,6.07V165c0,11.34-2.16,19.33-6.48,23.99
                        c-4.32,4.66-10.52,6.98-18.62,6.98h-81.77c-10.26,0-18.96-0.94-26.11-2.83c-7.15-1.89-12.99-4.96-17.51-9.21
                        c-4.52-4.25-7.83-9.78-9.92-16.6c-2.09-6.81-3.14-15.08-3.14-24.8v-34.81c0-9.72,1.04-17.95,3.14-24.69
                        c2.09-6.75,5.39-12.25,9.92-16.5c4.52-4.25,10.35-7.35,17.51-9.31c7.15-1.95,15.85-2.93,26.11-2.93H812.48z"/>
                      <path class="st0" d="M986.34,54.29c3.1,0,4.66,1.49,4.66,4.45v19.23c0,2.97-1.55,4.45-4.66,4.45h-88.45
                        c-5.26,0-9.61,0.44-13.05,1.32c-3.44,0.88-6.21,2.36-8.3,4.45c-2.09,2.09-3.54,4.93-4.35,8.5c-0.81,3.58-1.21,8-1.21,13.26v2.03
                        h114.36c2.97,0,4.45,1.49,4.45,4.45v15.99c0,2.97-1.49,4.45-4.45,4.45H870.97v3.44c0,5.26,0.4,9.69,1.21,13.26
                        c0.81,3.58,2.26,6.41,4.35,8.5c2.09,2.09,4.86,3.58,8.3,4.45c3.44,0.88,7.79,1.32,13.05,1.32h88.45c3.1,0,4.66,1.49,4.66,4.45v19.23
                        c0,2.97-1.55,4.45-4.66,4.45h-89.06c-10.26,0-18.96-0.94-26.11-2.83c-7.15-1.89-12.99-4.96-17.51-9.21
                        c-4.52-4.25-7.83-9.78-9.92-16.6c-2.09-6.81-3.14-15.08-3.14-24.8v-34.81c0-9.72,1.04-17.95,3.14-24.69
                        c2.09-6.75,5.39-12.25,9.92-16.5c4.52-4.25,10.35-7.35,17.51-9.31c7.15-1.95,15.85-2.93,26.11-2.93H986.34z"/>
                      </svg>

                  </div>
                  <div v-if="collapsed || isMobile"></div>
                </router-link>
              </div>
              <div>
                <div class="btn-hidden-menu" @click="(isMobile) ? (btnHiddenMenu = !btnHiddenMenu) : (btnCollapsed = !btnCollapsed)">
                  <i class="fa fa-bars"></i>
                </div>
                  <div class="tarja-header-instituicao" v-if="[0, 1, 2, 3, 9, 12].includes(Number($store.state.user.tipo))">
                    <span> {{ $store.state.config.instituicao.nome }} </span>
                  </div>
                <ul class="menu-tarja-right">
                  <li class="imagem-avatar">
                    <div class="item">
                      <el-dropdown trigger="click" @command="clickSubMenu">
                        <span class="el-dropdown-link">
                          <span class="avatar">
                            <img v-if="!$store.state.user.imagem" src="@/assets/img/perfil.jpg">
                          </span>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="menu-sign">
                          <el-dropdown-item>
                            <i class="fa fa-user-circle"></i><span>{{ $store.state.user.name }}</span>
                          </el-dropdown-item>
                          <el-dropdown-item command="update-instituicao" divided v-if="[0, 1, 2, 3, 9, 12].includes(Number($store.state.user.tipo)) && $store.state.user.instituicoes.length > 1">
                            <i class="fas fa-home"></i><span>Trocar Instituição</span>
                          </el-dropdown-item>
                          <el-dropdown-item command="logout" divided>
                            <i class="fa fa-sign-out-alt"></i><span>Sair</span>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div id="collapsed" :class="{'collapsed' : collapsed}">
              <sidebar-menu :menu="menu" :btnCollapsed="btnCollapsed" :collapsed="collapsed" :isMobile="isMobile" :btnHiddenMenu="btnHiddenMenu" @collapse="onCollapse" @mobile="onMobile"/>
              <div v-if="getAmbiente() == 'homologacao'" class="tarja-ambiente-beta">
                Atenção! Este é um ambiente de teste - as matrículas realizadas aqui não possuem validade.
              </div>
              <div class="sub-tarja-header">
                <h1>{{ $route.meta.title }}</h1>
                <el-breadcrumb style="margin-top: 5px;" separator="/" v-if="$route.meta.breadcrumb">
                  <el-breadcrumb-item v-for="(item, index) in ($route.meta.breadcrumb || []).filter(item => item)" :key="index" :to="{ path: item.url }">{{ item.txt }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <router-view/>
            </div>
        </div>

        <div class="container-select-instituicao" v-if="[0, 1, 2, 3, 9, 12].includes(Number($store.state.user.tipo)) && !$store.state.config.instituicao.id">
              <c-panel class="c-panel-instituicao">
                  <h2 class="title-login">
                      <i class="far fa-user"></i>
                      Selecionar Instituição
                  </h2>
                  <el-form @submit.native.prevent="onSubmitSelectInstituicao" :model="config" ref="config" label-position="top">
                      <el-row :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24">
                              <el-form-item prop="instituicaoSelected" :rules="[$requiredChange]" key="instituicaoSelected">
                                  <el-select v-model="config.instituicaoSelected" filterable>
                                      <el-option v-for="(item, i) in $store.state.user.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24" class="u-text-right u-mt-20">
                              <el-button type="primary" native-type="submit">ENTRAR</el-button>
                          </el-col>
                      </el-row>
                  </el-form>
              </c-panel>
        </div>

      </template>

      <template v-else>

        <div class="container-select-instituicao">
          <c-panel class="c-panel-instituicao">
              <h2 class="title-login">
                  <i class="far fa-user"></i>
                  Cadastrar uma nova Senha
              </h2>
              <el-form @submit.native.prevent="onSubmitNovaSenha" :model="formNovaSenha" ref="formNovaSenha" label-position="top">
                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Senha" prop="password" :rules="[$requiredBlur]" key="password">
                            <el-input class="text-transform-none" v-model="formNovaSenha.password" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Confirma Senha" prop="password_confirmation" :rules="[$requiredBlur]" key="password_confirmation">
                            <el-input class="text-transform-none" v-model="formNovaSenha.password_confirmation" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24" class="u-text-right u-mt-20">
                          <el-button type="primary" native-type="submit">CADASTRAR SENHA</el-button>
                      </el-col>
                  </el-row>
              </el-form>
          </c-panel>
        </div>

      </template>

    </template>

    <div v-if="$store.state.loading" class="loading-layout"></div>

    <el-dialog append-to-body title="DOCUMENTO" :close-on-click-modal="false" :visible.sync="dialogPrint" width="80%" top="5vh" class="ss-header-dialog-print">
        <div v-if="dialogPrint">

          <div v-if="loadingPdf">
            <p class="u-text-center">
              ATENÇÃO: O processo de geração de PDF pode demorar vários minutos para ser renderizado dependendo da quantidade de
              registros no relatório.
            </p>
            <div style="text-align: center; margin: 50px 0px;">
              <img src="/public/img/loading-bar.gif" />
            </div>
          </div>
          <div class="u-text-center" style="color: #ff0000; margin: 50px 0px;" v-if="loadingPdfErro">
            Ops! Algo de errado aconteceu ao gerar o relatório. Por favor, entre em contato com o setor de legalização da SMED.
          </div>
          <iframe ref="myDiv"  id="iframe" scrolling="no" style="width: 100%; height: 130vh; border: none;" src="" >
            <p>Relatório indisponível! Seu navegador não é compatível.</p>
          </iframe>
        </div>
    </el-dialog>

    <el-dialog class="ss-loading" top="0" width="200px" :visible.sync="loading" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
        <div style="text-align: center;">
          <img src="/public/img/loading.gif" />
        </div>
    </el-dialog>

    <el-dialog append-to-body title="ATENÇÃO" :close-on-click-modal="false" :visible.sync="$store.state.dialogMensagem" width="70%" top="2vh" class="ss-header-dialog-print">
        <div style="margin-top: 20px;" v-if="$store.state.msg.smge_msg">
          {{ $store.state.msg.smge_msg }}
        </div>
        <div style="margin-top: 20px;" v-if="$store.state.msg.smge_msg_video">
          <video controls style="width: 100%; height: auto;">
            <source :src="$store.state.msg.smge_msg_video" type="video/mp4">
            Seu navegador não suporta a tag de vídeo.
          </video>
        </div>
        <div class="u-text-right u-mt-10">
              <el-button type="primary" @click="$store.state.dialogMensagem = false">FECHAR</el-button>
          </div>
    </el-dialog>
    
  </div>
</template>
<script>

import SidebarMenu from './menu/SidebarMenu.vue'

export default {
  name: "index",
  data: () => ({
    loadingPdfErro: false,
    loadingPdf: false,
    valid: [],
    dialogValid: false,
    config: {
      instituicaoSelected: ''
    },
    btnHiddenMenu: true,
    dialogPrint: false,
    loading: null,
    menu: [
      
      { header: true, title: 'Matrículas', tipoUser: [0, 1, 3, 4, 5, 6, 7, 9, 10, 11, 12] },
      { href: '/admin/aluno', title: 'Alunos', icon: 'fas fa-user-graduate', tipoUser: [0, 1, 3, 4, 5, 6, 7, 9, 10, 11, 12] },

      {
        title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt'},
          { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos Novatos', icon: 'fa fa-list-alt' },
          // { href: '/admin/pre-matricula-inscritos', title: 'Inscritos', icon: 'fa fa-list-alt' },
          // { href: '/admin/pre-matricula-inscritos-pcd', title: 'Inscritos PCD', icon: 'fa fa-list-alt' }
        ]
      },

      {
        title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [7, 11], child:
        [          
          { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos Novatos', icon: 'fa fa-list-alt' },
          // { href: '/admin/pre-matricula-inscritos', title: 'Inscritos', icon: 'fa fa-list-alt' },
          // { href: '/admin/pre-matricula-inscritos-pcd', title: 'Inscritos PCD', icon: 'fa fa-list-alt' }
        ]
      },

      {
        title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [0, 1, 12], child:
        [
          { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt', tipoUser: [0, 1, 12] },
          { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos Novatos', icon: 'fa fa-list-alt' },
          // { href: '/admin/pre-matricula-inscritos', title: 'Inscritos', icon: 'fa fa-list-alt', tipoUser: [0, 1, 12] },
          // { href: '/admin/pre-matricula-inscritos-pcd', title: 'Inscritos', icon: 'fa fa-list-alt', tipoUser: [0, 1, 12] }
        ]
      },

      { href: '/admin/autorizacao', title: 'Autorizações Smed', icon: 'fas fa-user-graduate', tipoUser: [4, 6] },
      { href: '/admin/vagas', title: 'Vagas do Município', icon: 'fas fa-chalkboard-teacher', tipoUser: [4, 6, 7] },
      { href: '/admin/matriculas-tempo-real', title: 'Matrículas Tempo Real', icon: 'fas fa-history', tipoUser: [0, 1, 3, 4, 5, 6, 7, 9, 11, 12] },

      { header: true, title: 'Diário', tipoUser: [0, 1, 2, 3, 5, 6, 7, 11, 12] },

      { href: '/admin/diario/aluno', title: 'Diário', icon: 'far fa-id-card', tipoUser: [0, 1, 3, 5, 6, 7, 11, 12] },
      { href: '/admin/diario/fase', title: 'Fechamento', icon: 'far fa-id-card', tipoUser: [0, 1, 3, 6, 7, 12] },
      { href: '/admin/diario/conferencia', title: 'Conferência', icon: 'far fa-id-card', tipoUser: [0, 1, 2, 3, 5, 6, 7, 11, 12] },
      { href: '/admin/diario/parametros', title: 'Parâmetros', icon: 'far fa-id-card', tipoUser: [4, 6] },
      { href: '/admin/diario/parametros-rede', title: 'Parâmetros Rede', icon: 'far fa-id-card', tipoUser: [4] },
      { href: '/admin/diario/gerenciar-frequencia', title: 'Gerenciar Frequência', icon: 'far fa-id-card', tipoUser: [4, 6] },
      { href: '/admin/diario/conflitos-frequencia', title: 'Conflitos Frequência', icon: 'far fa-id-card', tipoUser: [0, 1, 3, 12] },
      { href: '/admin/diario/boletim', title: 'Boletim', icon: 'far fa-id-card', tipoUser: [0, 1, 3, 4, 5, 6, 7, 11, 12] },

      { header: true, title: 'Pedagógico', tipoUser: [3, 4, 7] },
      { href: '/admin/planejamento', title: 'Planejamentos Semanais', icon: 'fas fa-book-open', tipoUser: [3, 4, 7] },

      { header: true, title: 'Instituição', tipoUser: [0, 1, 3, 4, 6, 7, 9, 10, 11, 12] },

      {
        title: 'Educacenso', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/educacenso', title: '1ª Etapa 2026', icon: 'fa fa-list-alt' },
          { href: '/admin/educacenso/etapa-final', title: '2ª Etapa 2026', icon: 'fa fa-list-alt' },
          { href: '/admin/alteracao-nome', title: 'Alteração de Nome', icon: 'far fa-copy' },
          { href: '/admin/educacenso/importa-inep', title: 'Importação do Censo', icon: 'fa fa-file-import' },
        ]
      }, 
      
      { href: '/admin/educacenso/inicio', title: 'Iniciar Educacenso', icon: 'fas fa-cogs', tipoUser: [4] },

      {
        title: 'Educacenso', icon: 'fa fa-sitemap', tipoUser: [0, 1, 3, 12], child:
        [
          { href: '/admin/educacenso', title: '1ª Etapa', icon: 'fa fa-list-alt' },
          { href: '/admin/educacenso/etapa-final', title: '2ª Etapa', icon: 'fa fa-list-alt' },
        ]
      }, 

      { href: '/admin/instituicao/index', title: 'Instituição', icon: 'fas fa-home', tipoUser: [0, 1, 4, 6, 7, 9, 12] },
      { href: '/admin/instituicao/calendario-letivo', title: 'Add Dia Letivo', icon: 'fas fa-calendar-plus', tipoUser: [4, 5, 6] },
      { href: '/admin/curso', title: 'Cursos', icon: 'fas fa-align-left', tipoUser: [4, 6] },
      { href: '/admin/turma', title: 'Turmas', icon: 'fas fa-door-closed', tipoUser: [5,7, 9, 10, 11] },
      
      {
        title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [0, 1, 3, 12], child:
        [
          { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/turma/situacao-academica-turmas', title: 'Situação Acadêmica', icon: 'far fa-copy' },
        ]
      },
      
      {
        title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/turma/projecao', title: 'Projeção', icon: 'fa fa-list-alt' },
        ]
      },
      { href: '/admin/servidor', title: 'Servidor', icon: 'fas fa-user-tie', tipoUser: [0, 1, 3, 4, 5, 6, 7, 9, 11, 12] },

      { header: true, title: 'Sistema', tipoUser: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12] },
      {
        title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [4, 5, 6, 7], child:
        [
          { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/instituicao', title: 'Instituições', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/servidor', title: 'Servidores', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/especial', title: 'Especiais', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/diario-frequencia', title: 'Frequência', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/nota', title: 'Notas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/diario-pendencias', title: 'Pendências Diário', icon: 'fa fa-list-alt' },
          // { href: '/admin/relatorio/relatorio-inscritos', title: 'Pré-Matrícula', icon: 'fa fa-list-alt' },
          { href: '#', title: 'Req. Matrícula em Branco', icon: 'fa fa-list-alt', click: 'req-matricula' }
        ]
      },
      {
        title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [0, 1, 3, 12], child:
        [
          { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/instituicao', title: 'Instituições', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/servidor', title: 'Servidores', icon: 'fa fa-list-alt' },
          // { href: '/admin/relatorio/relatorio-inscritos', title: 'Pré-Matrícula', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/diario-frequencia', title: 'Frequência', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/nota', title: 'Notas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/diario-pendencias', title: 'Pendências Diário', icon: 'fa fa-list-alt' },
          { href: '#', title: 'Req. Matrícula em Branco', icon: 'fa fa-list-alt', click: 'req-matricula' },
        ]
      },
      {
        title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [8, 9, 11], child:
        [
          { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/instituicao', title: 'Instituições', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/servidor', title: 'Servidores', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/diario-frequencia', title: 'Frequência', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/nota', title: 'Notas', icon: 'fa fa-list-alt' },
        ]
      },
      {
        title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [10], child:
        [
          { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/instituicao', title: 'Instituições', icon: 'fa fa-list-alt' },          
        ]
      },
      { href: '/admin/usuario', title: 'Usuário', icon: 'far fa-user-circle', tipoUser: [4, 5, 6] },
      // { href: '/admin/suporte', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6, 9] },
      { href: '/admin/log', title: 'Logs', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 3, 4, 5, 6, 12] },
      { href: '/admin/log-diario', title: 'Logs Diário', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 3, 4, 5, 6, 12] },
      { href: '/admin/log-pre-matricula', title: 'Logs Pré-matrícula', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 5, 6] },
      // { href: '#', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6] },
      { href: '/admin/ajuda', title: 'Ajuda', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 2, 3, 4, 5, 6, 9, 12] },
      { href: '/admin/calculadora', title: 'Calculadora de Idade', icon: 'fas fa-calculator', tipoUser: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
      
      { href: '/admin/calendario-agendamento', title: 'calendário de agendamento', icon: 'fas fa-calendar', tipoUser: [4] },

      { href: '/admin/sistema', title: 'Período Letivo', icon: 'fas fa-cogs', tipoUser: [4] },
      {
        title: 'Cadastros Gerais', icon: 'fa fa-sitemap', tipoUser: [4, 5, 6], child:
        [
          { href: '/admin/endereco', title: 'Endereço', icon: 'fa fa-list-alt' },
          { href: '/admin/dados-medicos', title: 'Dados Médicos', icon: 'fa fa-list-alt' },
          { href: '/admin/disciplina', title: 'Disciplinas', icon: 'fa fa-list-alt' },
          { href: '/admin/instituicao-superior', title: 'Inst. Nível Superior', icon: 'fa fa-list-alt' },
          { href: '/admin/curso-superior', title: 'Cursos N. Superior', icon: 'fa fa-list-alt' },
          { href: '/admin/curso-complementar', title: 'Cursos Complementar', icon: 'fa fa-list-alt' },
          { href: '/admin/atividade-complementar', title: 'Ativid. Complementar', icon: 'fa fa-list-alt' },
          { href: '/admin/alergia', title: 'Alergias', icon: 'fa fa-list-alt' },
          { href: '/admin/deficiencia', title: 'Deficiências', icon: 'fa fa-list-alt' },
          { href: '/admin/doenca', title: 'Doenças', icon: 'fa fa-list-alt' }
        ]
      },


    ],
    collapsed: false,
    btnCollapsed: false,
    isMobile: false,
    formNovaSenha:{
      password: '',
      password_confirmation: '',
      cadastrar_senha: false
    }
  }),
  async mounted(){
    
    this.$store.dispatch('getUser');
  },
  methods: {
    onSubmitNovaSenha(){

      this.$refs.formNovaSenha.validate((valid) =>{ if(valid){

        window.eventBus.$emit('loading', true);

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/update/${this.$store.state.user.id}`, this.formNovaSenha, this.$store.getters.getHeaderAuth).then(response => {

            if(typeof response.data.throw !== 'undefined'){

              window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});
              window.eventBus.$emit('loading', false);

            }else{

              window.eventBus.$emit('loading', false);
              window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

              this.$store.dispatch('getUser');
            }

        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });


      }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});


    },
    onCollapse(val) {
      this.collapsed = val
    },
    onMobile(val) {
      this.isMobile = val
    },
    clickSubMenu(clicado){

      if(clicado){

        if(clicado == 'logout'){

          this.logout();

        }else if(clicado == 'update-instituicao'){

          this.$store.commit('setInstituicao', false);

        }else if(clicado == 'perfil'){

          this.$router.push('/admin/perfil');

        }
      }

    },
    onSubmitSelectInstituicao() {

      this.$refs.config.validate((valid) =>{ if(valid){

        for(let i in this.$store.state.user.instituicoes){

          if(this.$store.state.user.instituicoes[i].id == this.config.instituicaoSelected){

            this.$store.commit('setInstituicao', this.$store.state.user.instituicoes[i]);
          }

        }

      }});

    },
    logout(){

      this.$store.commit('logout');
    },
    getAmbiente() {

      if((window.location.href).includes("https://smge.pmvc.ba.gov.br")) {
        return 'producao';
      }else if((window.location.href).includes("localhost")) {
        return 'local';
      }
      return 'homologacao';
    },
  },
  created: function(){

      window.eventBus.$on('alert', data =>  {

          let time = 3000;

          if(data.type == 'error' || data.type == 'warning')
            time = 6000;

          this.$message({
            message: data.msg,
            type: data.type,
            duration: time
          });

      });

      window.eventBus.$on('loading', data =>  {

          this.loading = data;
      });

      window.eventBus.$on('print', async (data) => {
        this.dialogPrint = true;
        this.loadingPdfErro = false;
        this.loadingPdf = true;

        const instance = this;
        const url = this.$store.state.config.baseUrlApi + data.url;

        try {
          await instance.$nextTick();

          const iframe = instance.$refs.myDiv;

          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + sessionStorage.getItem("ed543672Token"),
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ param: data.param }),
          });

          if (!response.ok) throw new Error(`Erro HTTP ${response.status}`);

          const blob = await response.blob();
          iframe.src = URL.createObjectURL(blob);

          instance.loadingPdf = false;
        } catch (err) {
          
          instance.loadingPdf = false;
          instance.loadingPdfErro = true;
        }
      });

      window.eventBus.$on('throw', data =>  {

          let alertas = '';

          for(let i in data){

            alertas += data[i].msg;

            if(i != data.length){

              alertas += '<br>';
            }

          }

          this.$alert(alertas, 'Atenção!', { dangerouslyUseHTMLString: true, confirmButtonText: 'OK' }).then(() => { }).catch(() => { });

          this.dialogValid = true;
          this.valid = data;
      });

  },
  components: {
    SidebarMenu
  }
};
</script>
<style type="text/css">
  .st0{fill:#FFFFFF;}
</style>

<style scoped>
  .tarja-ambiente-beta {
    background-color: #ff0000;
    color: #fff;
    text-align: center;
    font-weight: bold;
    padding: 5px;
    position: relative;
    bottom: 0;
    width: 100%;
  }
</style>